import { render, staticRenderFns } from "./Meeting.LogoutBtn.vue?vue&type=template&id=242080c4&scoped=true"
import script from "./Meeting.LogoutBtn.vue?vue&type=script&lang=js"
export * from "./Meeting.LogoutBtn.vue?vue&type=script&lang=js"
import style0 from "./Meeting.LogoutBtn.vue?vue&type=style&index=0&id=242080c4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242080c4",
  null
  
)

export default component.exports